module.exports = __webpack_public_path__ + "naevisoddities.jpg?b7eafb7466f28bf02c3df353a0aed10a";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/naevisoddities.jpg
// module id = 685
// module chunks = 0